import * as React from 'react';
import {
    ShowButton,
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    Filter,
    ReferenceField,
    ReferenceInput,
    SelectInput,
    BooleanField,
} from 'react-admin';
import RecurrenceField from './RecurrenceField'

const ScheduleFilter = props => (
    <Filter {...props}>
        <TextInput label="Search" source="q" />
        <ReferenceInput
            label="Resource"
            source="resource_id"
            reference="resources"
            allowEmpty
        >
            <SelectInput optionText="name" />
        </ReferenceInput>
    </Filter>
);

const ScheduleList = props => (
    <List {...props} filters={<ScheduleFilter />}>
        <Datagrid>
            <TextField source="id" />
            <ReferenceField label="Resource" source="resource_id" reference="resources">
                <TextField source="name" />
            </ReferenceField>
            <ReferenceField label="Target" source="target_id" reference="targets">
                <TextField source="name" />
            </ReferenceField>
            <TextField source="recurrence.frequency" label="Frequency" />
            {/* <TextField source="start_time" /> */}
            <RecurrenceField source="rrule" />
            <BooleanField source="enabled" />
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

export default ScheduleList;